import toast from 'react-hot-toast';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';

import { sendErrorReport } from '../../shared/utilities/sendErrorReport';

import * as actions from './actions';
import * as api from './api';

import {
    PostMessageTemplateRequestAction,
    DeleteMessageTemplateRequestAction,
    PatchMessageTemplateRequestAction,
    SerializedMessageTemplate,
} from './types';

function* getAllMessageTemplatesFlow(): SagaIterator {
    try {
        const apiResponse: SerializedMessageTemplate = yield call(api.fetchMessageTemplates);
        yield put(actions.getAllMessageTemplatesSuccess(apiResponse.messageTemplate));
    } catch (e) {
        yield put(actions.getAllMessageTemplatesFailure((e as Error).message));
        sendErrorReport(e as Error);
    }
}

function* deleteMessageTemplateFlow({ id }: DeleteMessageTemplateRequestAction): SagaIterator {
    try {
        yield call(api.deleteMessageTemplate, id);
        yield put(actions.deleteMessageTemplateSuccess(id));
    } catch (e) {
        yield put(actions.deleteMessageTemplateFailure((e as Error).message));
        toast.error('global.generic_error');
        sendErrorReport(e as Error);
    }
}

function* postMessageTemplateFlow({
    messageTemplate,
    onSuccess,
}: PostMessageTemplateRequestAction): SagaIterator {
    try {
        const apiResponse: SerializedMessageTemplate = yield call(
            api.postMessageTemplate,
            messageTemplate,
        );
        yield put(actions.postMessageTemplateSuccess(apiResponse.messageTemplate));
        onSuccess();
    } catch (e) {
        yield put(actions.postMessageTemplateFailure((e as Error).message));
        toast.error('templates.bo.notification.create_error');
        sendErrorReport(e as Error);
    }
}

function* patchMessageTemplateFlow({
    messageTemplate,
    onSuccess,
}: PatchMessageTemplateRequestAction): SagaIterator {
    try {
        yield call(api.patchMessageTemplate, messageTemplate);
        yield put(actions.patchMessageTemplateSuccess(messageTemplate, messageTemplate.id));
        toast.success('templates.bo.notification.update_success');
        onSuccess();
    } catch (e) {
        yield put(actions.patchMessageTemplateFailure((e as Error).message, messageTemplate.id));
        toast.error('global.generic_error');
        sendErrorReport(e as Error);
    }
}

export function* messageTemplatesWatcher(): SagaIterator {
    yield takeLatest(actions.getAllMessageTemplatesRequestAction, getAllMessageTemplatesFlow);
    yield takeLatest(actions.postNewMessageTemplateRequestAction, postMessageTemplateFlow);
    yield takeLatest(actions.updateMessageTemplateRequestAction, patchMessageTemplateFlow);
    yield takeEvery(actions.deleteMessageTemplateRequestAction, deleteMessageTemplateFlow);
}
